// 
import { Injectable } from "@angular/core";
import { SinglePurposeItem } from "../models/shared-models";

@Injectable()
export class NewDashboardPurposeList {

    public static dashboardMenuList = ['STUDENT', 'OTHERS', 'FOREXCARD','CURRENCYNOTES'];

    public static addONServiceList = [ 'TRAVELINSURANCE', 'OPENGICACCOUNT', 'BLOCKEDACCOUNT', 'ISICCARD', 'ESIM', 'LOUNGE', 'TRAVELTRANSIT'];

    public static studentMenuList = ['UniversityFees', 'UniversityFeesOwnAccount', 'StudentLivingExpenses', 'GIC', 'BlockAccount'];

    public static personalMenuList = ['TourRemittance', 'EmigrationFee', 'MedicalExpenses', 'VisaFee', 'ExaminationFees', 'JobVisit', 'SpecialisedTrainingFees', 'InternationalCompetitionFees', 'AttendingConference', 'FamilyMaintenance']; /*  */
    public static remittanceDashPersonalMenuList = ['TourRemittance', 'EmigrationFee', 'MedicalExpenses', 'VisaFee', 'ExaminationFees', 'JobVisit', 'SpecialisedTrainingFees', 'InternationalCompetitionFees', 'AttendingConference', 'FamilyMaintenance'];

    public static ad1MenuList = ['FamilyMaintenance'];

    public static homePagePurposeList = [
        {
            'key': 'STUDENT',
            'icon': 'assets/images/smartfx-portal-assets/dashboard-global-pay/stud-remittance.png',
            'src': "assets/images/smartfx-portal-assets/dashboard-global-pay/stud-remittance.png",
            "iconW": "assets/images/smartfx-portal-assets/dashboard-global-pay/stud-remittance-white.png",
            'title': 'Student Remittance',
            'isActive': false,
            "purposeCode": "UNIVERSITY_FEES",
            "remittanceType": "STUDENT",
            "isPurpose": "true",
            "pageUrl": ''
        },
        {
            'key': 'OTHERS',
            'icon': 'assets/images/smartfx-portal-assets/dashboard-global-pay/personal-remittance.png',
            'src': "assets/images/smartfx-portal-assets/dashboard-global-pay/personal-remittance.png",
            "iconW": "assets/images/smartfx-portal-assets/dashboard-global-pay/personal-remittance-white.png",
            'title': 'Personal Remittance',
            'isActive': false,
            "purposeCode": "UNIVERSITY_FEES",
            "remittanceType": "STUDENT",
            "isPurpose": "true",
            "pageUrl": ''
        },
          {
            'key': 'AD1',
            "icon": "assets/images/smartfx-portal-assets/personal-remittance/new-gift.png",
            'src': "assets/images/smartfx-portal-assets/personal-remittance/new-gift.png",
            "iconW": "assets/images/smartfx-portal-assets/personal-remittance/new-gift-white.png",
            'title': 'Gift & Family',
            'isActive': false,
            "purposeCode": "UNIVERSITY_FEES",
            "remittanceType": "OTHERS",
            "isPurpose": "true",
            "pageUrl": ''
        },
        {
            'key': 'FOREXCARD',
            'icon': 'assets/images/smartfx-portal-assets/dashboard-global-pay/forex-card-icon-2.png',
            'src': "assets/images/smartfx-portal-assets/dashboard-global-pay/forex-card-icon-2.png",
            "iconW": "assets/images/smartfx-portal-assets/dashboard-global-pay/forex-card-icon-2-white.png",
            'title': 'Forex Card',
            'isActive': false,
            "purposeCode": "UNIVERSITY_FEES",
            "remittanceType": "STUDENT",
            "isPurpose": "true",
            "pageUrl": 'my-card'
        },
        {
            'key': 'CURRENCYNOTES',
            'icon': 'assets/images/smartfx-portal-assets/dashboard-global-pay/CurrencyNote.png',
            'src': "assets/images/smartfx-portal-assets/dashboard-global-pay/CurrencyNote.png",
            "iconW": "assets/images/smartfx-portal-assets/dashboard-global-pay/CurrencyNote-white.png",
            'title': 'Currency Notes',
            'isActive': false,
            "purposeCode": "PRIVATE_VISIT",
            "remittanceType": "STUDENT",
            "isPurpose": "true",
            "pageUrl": 'sell-currency-notes'
        },
        {
            'key': 'TRAVELINSURANCE',
            'icon': 'assets/images/smartfx-portal-assets/dashboard-global-pay/travel-insurance.png',
            'src': "assets/images/smartfx-portal-assets/dashboard-global-pay/travel-insurance.png",
            "iconW": "assets/images/smartfx-portal-assets/dashboard-global-pay/travel-insurance-white.png",
            'title': 'Travel Insurance',
            'isActive': false,
            "purposeCode": "UNIVERSITY_FEES",
            "remittanceType": "STUDENT",
            "isPurpose": "true",
            "pageUrl": ''
        },
        {
            'key': 'OPENGICACCOUNT',
            'icon': 'assets/images/smartfx-portal-assets/dashboard-global-pay/open-gic-acc.png',
            'src': "assets/images/smartfx-portal-assets/dashboard-global-pay/open-gic-acc.png",
            "iconW": "assets/images/smartfx-portal-assets/dashboard-global-pay/open-gic-acc-white.png",
            'title': 'Open GIC Account',
            'isActive': false,
            "purposeCode": "UNIVERSITY_FEES",
            "remittanceType": "STUDENT",
            "isPurpose": "true",
            "pageUrl": ''
        },
        {
            'key': 'BLOCKEDACCOUNT',
            'icon': 'assets/images/smartfx-portal-assets/dashboard-global-pay/open-blocked-acc.png',
            'src': "assets/images/smartfx-portal-assets/dashboard-global-pay/open-blocked-acc.png",
            "iconW": "assets/images/smartfx-portal-assets/dashboard-global-pay/open-blocked-acc-white.png",
            'title': 'Open Blocked Account',
            'isActive': false,
            "purposeCode": "UNIVERSITY_FEES",
            "remittanceType": "STUDENT",
            "isPurpose": "true",
            "pageUrl": ''
        },
        // {
        //     'key': 'ZOLVEDCREDITCARD',
        //     'icon': 'assets/images/smartfx-portal-assets/dashboard-global-pay/zolve-credit-card.png',
        //     'src': "assets/images/smartfx-portal-assets/dashboard-global-pay/zolve-credit-card.png",
        //     "iconW": "assets/images/smartfx-portal-assets/dashboard-global-pay/zolve-credit-card-white.png",
        //     'title': 'Zolve Credit Card',
        //     'isActive': false,
        //     "purposeCode": "UNIVERSITY_FEES",
        //     "remittanceType": "STUDENT",
        //     "isPurpose": "true",
        //     "pageUrl": ''
        // },
        {
            'key': 'ISICCARD',
            'icon': 'assets/images/smartfx-portal-assets/dashboard-global-pay/isic-card.png',
            'src': "assets/images/smartfx-portal-assets/dashboard-global-pay/isic-card.png",
            "iconW": "assets/images/smartfx-portal-assets/dashboard-global-pay/isic-card-white.png",
            'title': 'ISIC Card',
            'isActive': false,
            "purposeCode": "UNIVERSITY_FEES",
            "remittanceType": "STUDENT",
            "isPurpose": "true",
            "pageUrl": ''
        },
        {
            "key": "UniversityFees",
            "title": "University Fees",
            "icon": "assets/images/smartfx-portal-assets/student-remittance/university-fees.png",
            'src': "assets/images/smartfx-portal-assets/student-remittance/university-fees.png",
            "iconW": "assets/images/smartfx-portal-assets/student-remittance/university-fees-white.png",
            "purposeCode": "UNIVERSITY_FEES",
            "remittanceType": "STUDENT",
            "isPurpose": "true",
            "pageUrl": ''
        },
        {
            "key": "UniversityFeesOwnAccount",
            "icon": "assets/images/smartfx-portal-assets/student-remittance/university-fees-own-account.png",
            'src': "assets/images/smartfx-portal-assets/student-remittance/university-fees-own-account.png",
            "iconW": "assets/images/smartfx-portal-assets/student-remittance/university-fees-own-account-white.png",
            "title": "University Fees Own Account",
            "purposeCode": "UNIVERSITY_FEES_OWN_ACCOUNT",
            "remittanceType": "STUDENT",
            "isPurpose": "true",
            "pageUrl": ''
        },
        {
            "key": "StudentLivingExpenses",
            "icon": "assets/images/smartfx-portal-assets/student-remittance/student-living-expenses.png",
            'src': "assets/images/smartfx-portal-assets/student-remittance/student-living-expenses.png",
            "iconW": "assets/images/smartfx-portal-assets/student-remittance/student-living-expenses-white.png",
            "title": "Student Living Expenses",
            "purposeCode": "STUDENT_LIVING_EXPENSES",
            "remittanceType": "STUDENT",
            "isPurpose": "true",
            "pageUrl": ''
        },
        {
            "key": "GIC",
            "title": "GIC Remittance",
            "icon": "assets/images/smartfx-portal-assets/student-remittance/open-gic-acc.png",
            'src': "assets/images/smartfx-portal-assets/student-remittance/open-gic-acc.png",
            "iconW": "assets/images/smartfx-portal-assets/student-remittance/open-gic-acc-white.png",
            "purposeCode": "GIC",
            "remittanceType": "STUDENT",
            "isPurpose": "true",
            "pageUrl": ''
        },
        {
            "key": "BlockAccount",
            "title": "Blocked Account Remittance",
            "icon": "assets/images/smartfx-portal-assets/student-remittance/open-blocked-acc.png",
            'src': "assets/images/smartfx-portal-assets/student-remittance/open-blocked-acc.png",
            "iconW": "assets/images/smartfx-portal-assets/student-remittance/open-blocked-acc-white.png",
            "purposeCode": "BLOCK_ACCOUNT",
            "remittanceType": "STUDENT",
            "isPurpose": "false",
            "pageUrl": ''
        },
        {
            "key": "TourRemittance",
            "title": "Tour Remittance",
            "icon": "assets/images/smartfx-portal-assets/personal-remittance/tour-remittance.png",
            'src': "assets/images/smartfx-portal-assets/personal-remittance/tour-remittance.png",
            "iconW": "assets/images/smartfx-portal-assets/personal-remittance/tour-remittance-white.png",
            "purposeCode": "TOUR_REMITTANCE",
            "remittanceType": "OTHERS",
            "isPurpose": "true",
            "pageUrl": ''
        },
        {
            "key": "EmigrationFee",
            "title": "Emigration",
            "icon": "assets/images/smartfx-portal-assets/personal-remittance/emigration-fees.png",
            'src': "assets/images/smartfx-portal-assets/personal-remittance/emigration-fees.png",
            "iconW": "assets/images/smartfx-portal-assets/personal-remittance/emigration-fees-white.png",
            "purposeCode": "EMIGRATION",
            "remittanceType": "OTHERS",
            "isPurpose": "true",
            "pageUrl": ''
        },
        {
            "key": "MedicalExpenses",
            "title": "Medical Expenses",
            "icon": "assets/images/smartfx-portal-assets/personal-remittance/medical-expenses.png",
            'src': "assets/images/smartfx-portal-assets/personal-remittance/medical-expenses.png",
            "iconW": "assets/images/smartfx-portal-assets/personal-remittance/medical-expenses-white.png",
            "purposeCode": "MEDICAL_EXPENSES",
            "remittanceType": "OTHERS",
            "isPurpose": "true",
            "pageUrl": ''
        },
        {
            "key": "VisaFee",
            "title": "Visa Fee",
            "icon": "assets/images/smartfx-portal-assets/personal-remittance/visa-fees.png",
            'src': "assets/images/smartfx-portal-assets/personal-remittance/visa-fees.png",
            "iconW": "assets/images/smartfx-portal-assets/personal-remittance/visa-fees-white.png",
            "purposeCode": "VISA_FEES",
            "remittanceType": "OTHERS",
            "isPurpose": "true",
            "pageUrl": ''
        },
        {
            "key": "ExaminationFees",
            "title": "Examination Fees",
            "icon": "assets/images/smartfx-portal-assets/personal-remittance/examination-fees.png",
            'src': "assets/images/smartfx-portal-assets/personal-remittance/examination-fees.png",
            "iconW": "assets/images/smartfx-portal-assets/personal-remittance/examination-fees-white.png",
            "purposeCode": "EXAMINATION_FEES",
            "remittanceType": "OTHERS",
            "isPurpose": "true",
            "pageUrl": ''
        },
        {
            "key": "JobVisit",
            "title": "Job Visit",
            "icon": "assets/images/smartfx-portal-assets/personal-remittance/job-visit.png",
            'src': "assets/images/smartfx-portal-assets/personal-remittance/job-visit.png",
            "iconW": "assets/images/smartfx-portal-assets/personal-remittance/job-visit-white.png",
            "purposeCode": "JOB_APPLICATION",
            "remittanceType": "OTHERS",
            "isPurpose": "true",
            "pageUrl": ''
        },
        {
            "key": "SpecialisedTrainingFees",
            "title": "Specialised Training Fees",
            "icon": "assets/images/smartfx-portal-assets/personal-remittance/specialised-training-fees.png",
            'src': "assets/images/smartfx-portal-assets/personal-remittance/specialised-training-fees.png",
            "iconW": "assets/images/smartfx-portal-assets/personal-remittance/specialised-training-fees-white.png",
            "purposeCode": "SPECIALISED_TRAINING_FEES",
            "remittanceType": "OTHERS",
            "isPurpose": "true",
            "pageUrl": ''
        },
        {
            "key": "InternationalCompetitionFees",
            "title": "International Competition Fees",
            "icon": "assets/images/smartfx-portal-assets/personal-remittance/international-competition-fees.png",
            'src': "assets/images/smartfx-portal-assets/personal-remittance/international-competition-fees.png",
            "iconW": "assets/images/smartfx-portal-assets/personal-remittance/international-competition-fees-white.png",
            "purposeCode": "INTERNATIONAL_COMPETITION_FEES",
            "remittanceType": "OTHERS",
            "isPurpose": "true",
            "pageUrl": ''
        },
        {
            "key": "AttendingConference",
            "title": "Attending Conference",
            "icon": "assets/images/smartfx-portal-assets/personal-remittance/attending-conference.png",
            'src': "assets/images/smartfx-portal-assets/personal-remittance/attending-conference.png",
            "iconW": "assets/images/smartfx-portal-assets/personal-remittance/attending-conference-white.png",
            "purposeCode": "ATTENDING_CONFERENCE",
            "remittanceType": "OTHERS",
            "isPurpose": "true",
            "pageUrl": ''
        },
        {
            "key": "BuyNewCard",
            "title": "Buy New Card",
            "icon": "assets/images/purposeIcon/buy-card.png",
            "purposeCode": "",
            "remittanceType": "FOREXCARD",
            "isPurpose": "false",
            "pageUrl": "/buy-new-card"
        },
        {
            "key": "LinkExistingCard",
            "title": "Link Existing Card",
            "icon": "assets/images/purposeIcon/payment-method.png",
            "purposeCode": "",
            "remittanceType": "FOREXCARD",
            "isPurpose": "false",
            "pageUrl": "/link-existing-card"
        },
        {
            "key": "ESIM",
            "title": "International SIM",
            "icon": "assets/images/smartfx-portal-assets/dashboard-global-pay/international-SIM.PNG",
            'src': "assets/images/smartfx-portal-assets/dashboard-global-pay/international-SIM.PNG",
            "iconW": "assets/images/smartfx-portal-assets/dashboard-global-pay/international-SIM-white.png",
            "purposeCode": "",
            "remittanceType": "OTHERS",
            "isPurpose": "false",
            "pageUrl": "/esim"
        },
        {
            "key": "LOUNGE",
            "title": "International Lounge Access",
            "icon": "assets/images/smartfx-portal-assets/dashboard-global-pay/international-lounge-access.png",
            'src': "assets/images/smartfx-portal-assets/dashboard-global-pay/international-lounge-access.png",
            "iconW": "assets/images/smartfx-portal-assets/dashboard-global-pay/international-lounge-access-white.png",
            "purposeCode": "",
            "remittanceType": "OTHERS",
            "isPurpose": "false",
            "pageUrl": "/lounge-access"
        },
        {
            "key": "Gift",
            "title": "Gift",
            "icon": "assets/images/smartfx-portal-assets/personal-remittance/new-gift.png",
            'src': "assets/images/smartfx-portal-assets/personal-remittance/new-gift.png",
            "iconW": "assets/images/smartfx-portal-assets/personal-remittance/new-gift-white.png",
            "purposeCode": "GIFT",
            "remittanceType": "OTHERS",
            "isPurpose": "true",
            "pageUrl": ''
        },
        {
            "key": "FamilyMaintenance",
            "title": "Family Maintenance",
            "icon": "assets/images/smartfx-portal-assets/personal-remittance/family-payments.png",
            'src': "assets/images/smartfx-portal-assets/personal-remittance/family-payments.png",
            "iconW": "assets/images/smartfx-portal-assets/personal-remittance/family-payments-white.png",
            "purposeCode": "FAMILY_MAINTENANCE",
            "remittanceType": "OTHERS",
            "isPurpose": "true",
            "pageUrl": ''
        },
        {
            "key": "TRAVELTRANSIT",
            "title": "Travel and Transit Services",
            "icon": "assets/images/smartfx-portal-assets/dashboard-global-pay/travel-transit-services.png",
            'src': "assets/images/smartfx-portal-assets/dashboard-global-pay/travel-transit-services.png",
            "iconW": "assets/images/smartfx-portal-assets/dashboard-global-pay/travel-transit-services-white.png",
            "purposeCode": "",
            "remittanceType": "OTHERS",
            "isPurpose": "false",
            "pageUrl": "/new-dashboard"
        },
        
    ];

    public static getPurposeObjectByRemittanceType(remittanceType: string) {
        let purposeSubMenu: Array<SinglePurposeItem> = [];
        NewDashboardPurposeList.homePagePurposeList.forEach(singlePurpose => {
            if (singlePurpose.remittanceType == remittanceType.toUpperCase()) {
                purposeSubMenu.push(singlePurpose);
            }
        });
        return purposeSubMenu;
    }

    public static getPurposeObjectByPurposeCodeStudentRemittance(purposeCode: string) {
        var returnPurpose: SinglePurposeItem;
        NewDashboardPurposeList.homePagePurposeList.forEach(singlePurpose => {
            if (singlePurpose.purposeCode == purposeCode) {
                returnPurpose = singlePurpose;
            }
        });
        return returnPurpose;
    }

    public static getDashboardMenu(){
        let mainMenuItems: Array<SinglePurposeItem> = [];
        NewDashboardPurposeList.homePagePurposeList.forEach(singleElement => {
             for (let i = 0; i < NewDashboardPurposeList.dashboardMenuList.length; i++) {
                if (singleElement.key == NewDashboardPurposeList.dashboardMenuList[i]) {
                    mainMenuItems.push(singleElement);
                }
             }
        });
        return mainMenuItems;
    }

    public static getAddOnMenu(){
        let mainMenuItems: Array<SinglePurposeItem> = [];
        NewDashboardPurposeList.homePagePurposeList.forEach(singleElement => {
             for (let i = 0; i < NewDashboardPurposeList.addONServiceList.length; i++) {
                if (singleElement.key == NewDashboardPurposeList.addONServiceList[i]) {
                    mainMenuItems.push(singleElement);
                }
             }
        });
        return mainMenuItems;
    }    

    public static getStudentSubMenu(){
        let mainMenuItems: Array<SinglePurposeItem> = [];
        NewDashboardPurposeList.homePagePurposeList.forEach(singleElement => {
             for (let i = 0; i < NewDashboardPurposeList.studentMenuList.length; i++) {
                if (singleElement.key == NewDashboardPurposeList.studentMenuList[i]) {
                    mainMenuItems.push(singleElement);
                }
             }
        });
        return mainMenuItems;
    }

    public static getPersonalSubMenu(){
        let mainMenuItems: Array<SinglePurposeItem> = [];
        NewDashboardPurposeList.homePagePurposeList.forEach(singleElement => {
             for (let i = 0; i < NewDashboardPurposeList.personalMenuList.length; i++) {
                if (singleElement.key == NewDashboardPurposeList.personalMenuList[i]) {
                    mainMenuItems.push(singleElement);
                }
             }
        });
        return mainMenuItems;
    }

    public static getPersonalSubMenuForRemDashboard(){
        let mainMenuItems: Array<SinglePurposeItem> = [];
        NewDashboardPurposeList.homePagePurposeList.forEach(singleElement => {
             for (let i = 0; i < NewDashboardPurposeList.remittanceDashPersonalMenuList.length; i++) {
                if (singleElement.key == NewDashboardPurposeList.remittanceDashPersonalMenuList[i]) {
                    mainMenuItems.push(singleElement);
                }
             }
        });
        return mainMenuItems;
    }

        public static getad1MenuList(){
        let mainMenuItems: Array<SinglePurposeItem> = [];
        NewDashboardPurposeList.homePagePurposeList.forEach(singleElement => {
             for (let i = 0; i < NewDashboardPurposeList.ad1MenuList.length; i++) {
                if (singleElement.key == NewDashboardPurposeList.ad1MenuList[i]) {
                    mainMenuItems.push(singleElement);
                }
             }
        });
        return mainMenuItems;
    }
    
    
}